import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { Eye, ArrowLeft } from "lucide-react";
import { usePreview } from "@/context/PreviewContext";

export const PreviewBanner = () => {
  const { preview, stopPreview } = usePreview();
  const navigate = useNavigate();
  const qc = useQueryClient();
  if (!preview) return null;

  const exit = () => {
    stopPreview();
    qc.clear();
    navigate("/admin");
  };

  return (
    <div
      data-testid="preview-banner"
      className="sticky top-0 z-50 flex flex-wrap items-center justify-between gap-2 px-4 py-2.5 text-white sm:px-6"
      style={{ background: "var(--p-accent)" }}
    >
      <div className="flex min-w-0 items-center gap-2.5 text-sm">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-white/20 px-2.5 py-1 text-[11px] font-bold uppercase tracking-[0.14em]">
          <Eye className="h-3.5 w-3.5" /> Viewing as producer
        </span>
        <span className="min-w-0 truncate font-semibold">{preview.name}</span>
        <span className="hidden shrink-0 rounded-full bg-white/20 px-2.5 py-1 text-[11px] font-bold uppercase tracking-[0.12em] sm:inline">
          Read-only
        </span>
      </div>
      <button
        data-testid="return-to-operator-btn"
        onClick={exit}
        className="flex shrink-0 items-center gap-1.5 rounded-full bg-white px-4 py-1.5 text-xs font-bold transition-colors hover:bg-white/90"
        style={{ color: "var(--p-accent)" }}
      >
        <ArrowLeft className="h-3.5 w-3.5" /> Return to Admin
      </button>
    </div>
  );
};
